import { render, staticRenderFns } from "./UmsApplicationRoles.vue?vue&type=template&id=740f5102&"
import script from "./UmsApplicationRoles.js?vue&type=script&lang=js&"
export * from "./UmsApplicationRoles.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports